module.exports = __webpack_public_path__ + "static/media/companynewsImg8.3d2c5277.jpg";